import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment-timezone";
import { useLocation } from "react-router-dom";
import Loader from "components/Loaders/Loader";
import { FaFilter, FaUserCircle } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "./LeaderBoard.css";
import {FaEnvelope, FaPhoneAlt, FaBuilding,FaGlobe,FaUsers,FaCity} from "react-icons/fa";
import blasterRight from "../../assets/blasterRight.png";
import blasterLeft from "../../assets/blasterLeft.png";
import StreakLeaderboard from "components/Teams/Leaderboard/StreakLeaderboard";
// @ts-ignore
import confetti from "canvas-confetti";

const PublicLeaderboard: React.FC = () => {
  const { state } = useLocation();
  const { group_uid, group_name } = state || {};

  const [leaderboard, setLeaderboard] = useState<any[]>([]);
  const today = new Date();
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const [duration, setDuration] = useState("weekly");
  const [filterType, setFilterType] = useState("overall_performance");
  // const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const beAddress = process.env.REACT_APP_API_URL;
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";
  const [isProfilePopupOpen, setIsProfilePopupOpen] = useState(false);
const [selectedUserProfile, setSelectedUserProfile] = useState<any>(null);
const [userImages, setUserImages] = useState<{ [key: string]: string | null }>({});
  const [showStreak, setShowStreak] = useState(false);

  const topThreeRaw = leaderboard.slice(0, 3);
  const topThree = [...topThreeRaw];

  for (let i = topThree.length; i < 3; i++) {
    topThree.push({
      user_uid: `placeholder-${i}`,
      user_name: "Not yet claimed",
      value: "--",
      unit: "",
      image: null,
    });
  }

  const loggedInUserIndex = leaderboard.findIndex(
    (entry) => entry.user_uid === userUid
  );
  const loggedInUser = loggedInUserIndex !== -1 ? leaderboard[loggedInUserIndex] : null;
  const isInTop3 = loggedInUserIndex > -1 && loggedInUserIndex < 3;

  let rest = leaderboard.slice(3).filter((entry) => entry.user_uid !== userUid);

  for (let i = leaderboard.length; i < 5; i++) {
    rest.push({
      user_uid: `placeholder-${i}`,
      user_name: "Not yet claimed",
      value: "--",
      unit: "",
      image: null,
    });
  }
  useEffect(() => {
    const now = moment.utc();
    let from: Date, to: Date;

    if (duration === "daily") {
      from = now.startOf("day").toDate();
      to = now.endOf("day").toDate();
    } else if (duration === "weekly") {
      from = now.startOf("isoWeek").toDate();

      const endOfWeek = now.endOf("isoWeek").toDate();
      const today = new Date();
      to = endOfWeek > today ? today : endOfWeek;
    } else {
      from = now.startOf("month").toDate();

      const endOfMonth = now.endOf("month").toDate();
      const today = new Date();
      to = endOfMonth > today ? today : endOfMonth;
    }

    setFromDate(from);
    setToDate(to);
    fetchLeaderboard(from, to, duration, filterType);

  }, [duration]);

  useEffect(() => {
    const today = new Date();
    if (toDate > today) {
      setToDate(today);
    }
  }, [toDate]);

  const fetchUserProfile = async (user_uid: string) => {
    try {
      const userImage = userImages[user_uid] || null;

      const response = await axios.get(`${beAddress}/api/public-user-profile`, {
        headers: {
          "session-uid": sessionUid,
          "user-uid": userUid,
          "Content-Type": "application/json",
        },
        params: {
          target_user_uid: user_uid,
        },
      });

      if (
        response.data.status === "Success" &&
        typeof response.data.data === "object"
      ) {
        const userData = response.data.data;
        userData.image = userImage;
        setSelectedUserProfile(userData);
        setIsProfilePopupOpen(true);
      } else {
        console.error("Invalid profile response");
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
    }
  };



  // useEffect(() => {
  //   const now = moment.utc();
  //   let from: Date, to: Date;

  //   if (duration === "daily") {
  //     from = now.startOf("day").toDate();
  //     to = now.endOf("day").toDate();
  //   } else if (duration === "weekly") {
  //     from = now.startOf("isoWeek").toDate();
  //     to = now.endOf("isoWeek").toDate();
  //   } else {
  //     from = now.startOf("month").toDate();
  //     to = now.endOf("month").toDate();
  //   }

  //   setFromDate(from);
  //   setToDate(to);

  //   // Fetch after setting
  //   fetchLeaderboard(from, to, duration, filterType);
  // }, [duration, filterType]);
  const fetchImagesByUid = async (imageUids: string[]): Promise<Record<string, string>> => {
    if (!imageUids || imageUids.length === 0) {
      return {};
    }

    try {

      const url = new URL(`${beAddress}/api/get-image-by-uid`);
      imageUids.forEach(uid => url.searchParams.append("image_uid_list", uid));
      url.searchParams.set("is_icon_img", "true");
      url.searchParams.set("is_feedback_image", "false");

      const res = await fetch(url.toString(), {
        headers: {
          "session-uid": sessionUid,
          "user-uid": userUid,
        },
      });

      const data = await res.json();

      if (data.status === "Success" && Array.isArray(data.data)) {
        return Object.fromEntries(
          data.data.map((item: any) => {
            if (item.default) return [item.image_uid, ""];
            return [item.image_uid, item.image];
          })
        );
      }
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }

    return {};
  };

  const fetchLeaderboard = async (
    fromDateOverride = fromDate,
    toDateOverride = toDate,
    currentDuration = duration,
    currentFilter = filterType
  ) => {
    setLoading(true);
    try {
      let from = moment.utc(fromDateOverride).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]");
      let to = moment.utc(toDateOverride).endOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]");

      const params: any = {
        from_datetime: from,
        to_datetime: to,
        group_uid,
        is_org_leaderboard: false,
      };

      if (currentFilter !== "overall_performance") {
        params.filter_type = currentFilter;
      }

      const response = await axios.get(`${beAddress}/api/get-team-leaderboard`, {
        headers: {
          "session-uid": sessionUid,
          "user-uid": userUid,
        },
        params,
      });
      if (response.data?.data) {
        const data = response.data.data;


        const imageUids = data
          .filter((m: any) => m.image_uid && m.image_uid !== "")
          .map((m: any) => m.image_uid);


        const imageResponse = await fetchImagesByUid(imageUids);


        const imagesMap: { [key: string]: string | null } = {};
        data.forEach((member: any) => {
          let imageSrc = null;

          if (member.image_uid && imageResponse[member.image_uid]) {
            const base64Img = imageResponse[member.image_uid];
            let mimeType = "image/png";

            if (base64Img.startsWith("R0lGODlh")) mimeType = "image/gif";
            else if (base64Img.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (base64Img.startsWith("iVBORw0KGgo")) mimeType = "image/png";

            imageSrc = `data:${mimeType};base64,${base64Img}`;
          }

          imagesMap[member.user_uid] = imageSrc;
        });


        setUserImages(imagesMap);
        setLeaderboard(data);
      }

    } catch (err) {
      console.error("Error fetching leaderboard:", err);
    } finally {
      setLoading(false);
    }
  };

    const fireSideConfetti = () => {
      // Left cannon
      confetti({
        particleCount: 60,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 0.4 },
        colors: ["#ffae00", "#ff0055", "#00c8ff", "#00ff88"],
      });
  
      // Right cannon
      confetti({
        particleCount: 60,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 0.4 },
        colors: ["#ffae00", "#ff0055", "#00c8ff", "#00ff88"],
      });
  
      // Floating soft rain
      var duration = 2 * 1000;
      var end = Date.now() + duration;
  
      (function frame() {
        confetti({
          particleCount: 3,
          startVelocity: 20,
          ticks: 300,
          origin: { x: Math.random(), y: -0.1 }
        });
  
        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      })();
    };
    useEffect(() => {
      if (!loading && leaderboard.length > 0) {
        fireSideConfetti();
      }
    }, [loading]);

  // useEffect(() => {
  //   fetchLeaderboard();
  // }, [fromDate, toDate, filterType, duration]);

  return (
    <div className="leaderboard-container">
        <div className="leaderboard-toggle">
          {!showStreak ? (
            <button
              className="toggle-btn"
              onClick={() => setShowStreak(true)}
            >
              Streak Leaderboard
            </button>
          ) : (
            <button
              className="toggle-btn"
              onClick={() => setShowStreak(false)}
            >
              Leaderboard
            </button>
          )}
        </div>

        <img src={blasterLeft} alt="Blaster Left" className="blaster left" />
                    <img src={blasterRight} alt="Blaster Right" className="blaster right" />
          {!showStreak ? (
                  <>
      <div className="leaderboard-title">{group_name} Team Leaderboard</div>

      <div className="duration-tabs-wrapper">
        {/* <div className="filter-item" onClick={() => setIsPopupOpen(true)}>
          <FaFilter className="filter-icon" />
          <span>Filter By</span>
        </div> */}

        <div className="duration-tabs">
          {["daily", "weekly", "monthly"].map((d) => (
            <button
              key={d}
              className={`tab-button ${duration === d ? "active" : ""}`}
              onClick={() => setDuration(d)}
            >
              {d.charAt(0).toUpperCase() + d.slice(1)}
            </button>
          ))}
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : (
        <>
          {/* Top 3 */}
          <div className="leaderboard-members-list">
            {topThree.map((member, index) => {
              const imageSrc = userImages[member.user_uid];


              return (
                <div
                  key={member.user_uid}
                  className={`leaderboard-member-card ${index === 0
                    ? "first-place"
                    : index === 1
                      ? "second-place"
                      : "third-place"
                    }`}
                  onClick={() => {
                    if (!member.user_uid.startsWith("placeholder")) {
                      fetchUserProfile(member.user_uid);
                    }
                  }}
                >
                  {imageSrc ? (
                    <img
                      src={imageSrc}
                      alt={member.user_name}
                      className="leaderboard-image"
                    />
                  ) : (
                    <FaUserCircle style={{ fontSize: "100px", color: "gray" }} />
                  )}

                  <div className="leaderboard-progress-circle">{index + 1}</div>
                  <div className="leaderboard-member-info">
                    <p className="leaderboard-name">{member.user_name}</p>
                    <span className="leaderboard-points">
                      {member.value} {member.unit}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Lower List */}
          <div className="leaderboard-list">
            {loggedInUser && !isInTop3 && (
              <div
                key="you-highlight"
                className="leaderboard-list-item you-highlight"
              >
                <div className="leaderboard-list-item1">
                  <div className="leaderboard-rank-list1">
                    {leaderboard.findIndex((entry) => entry.user_uid === loggedInUser.user_uid) + 1}
                  </div>
                  <div className="leadership-name-image-container">
                    {loggedInUser.image ? (
                      <img
                        src={`data:image/png;base64,${loggedInUser.image}`}
                        alt={loggedInUser.user_name}
                        className="leaderboard-list-image"
                      />
                    ) : (
                      <FaUserCircle style={{ fontSize: "40px", color: "black" }} />
                    )}
                    <p className="leaderboard-list-name">
                      {loggedInUser.user_name}{" "}
                      <span style={{ fontWeight: 500 }}>(You)</span>
                    </p>
                  </div>
                </div>
                <div className="leaderboard-list-points">
                  {loggedInUser.value} {loggedInUser.unit === "count" ? "Steps" : loggedInUser.unit}
                </div>
              </div>
            )}
            {rest.map((member, index) => {
              const actualIndex = leaderboard.findIndex(
                (entry) => entry.user_uid === member.user_uid
              );
              const actualRank = actualIndex !== -1 ? actualIndex + 1 : "--";

              const imageSrc = userImages[member.user_uid];

              return (
                <div
                  key={member.user_uid}
                  className="leaderboard-list-item"
                  onClick={() => {
                    if (!member.user_uid.startsWith("placeholder")) {
                      fetchUserProfile(member.user_uid);
                    }
                  }}
                >
                  <div className="leaderboard-list-item1">
                    <div className="leaderboard-rank-list1">{actualRank}</div>
                    <div className="leadership-name-image-container">
                      {imageSrc ? (
                        <img
                          src={imageSrc}
                          alt={member.user_name}
                          className="leaderboard-list-image"
                        />
                      ) : (
                        <FaUserCircle className="leaderboard-list-image" style={{ fontSize: "100px", color: "gray" }} />
                      )}

                      <p className="leaderboard-list-name">
                        {member.user_uid?.startsWith("placeholder")
                          ? "Not yet claimed"
                          : member.user_name}
                      </p>
                    </div>
                  </div>
                  <div className="leaderboard-list-points">
                    {member.user_uid?.startsWith("placeholder")
                      ? "--"
                      : `${member.value} ${member.unit === "count" ? "Steps" : member.unit
                      }`}
                  </div>
                </div>
              );
            })}

          </div>
        </>
      )}
      {/* {isPopupOpen && (
        <div className="leaderboard-popup">
          <div className="leaderboard-popup-content">
            <span className="leaderboard-close" onClick={() => setIsPopupOpen(false)}>
              &times;
            </span>
            <h2 className="leaderboard-popup-title">Filters</h2>

            <div className="leaderboard-filter-group">
              <label className="leaderboard-label">Select Metrics:</label>
              <select
                className="leaderboard-select"
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
              >
                <option value="overall_performance">Overall Performance</option>
                <option value="steps">Steps</option>
                <option value="distance">Distance</option>
                <option value="caloriesburned">Calories Burned</option>
              </select>
            </div>

            <div className="leaderboard-filter-group">
              <label className="leaderboard-label">From Date:</label>
              <DatePicker
                selected={fromDate}
                onChange={(date) => {
                  const newFrom = date!;
                  setFromDate(newFrom);

                  if (toDate < newFrom) {
                    setToDate(newFrom);
                  }
                }}

                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="leaderboard-datepicker"
              />


            </div>
            <div className="leaderboard-filter-group">
              <label className="leaderboard-label">To Date:</label>
              <DatePicker
                selected={toDate}
                onChange={(date) => setToDate(date!)}
                minDate={fromDate}
                maxDate={new Date()}
                dateFormat="yyyy-MM-dd"
                className="leaderboard-datepicker"
              />

            </div>

            <button
              className="leaderboard-apply-button"
              onClick={() => {
                setIsPopupOpen(false);
                fetchLeaderboard(fromDate, toDate, duration, filterType);
              }}
            >
              Apply
            </button>

          </div>
        </div>
      )} */}

      {isProfilePopupOpen && selectedUserProfile && (
        <div className="member-profile-popup">
          <div className="member-profile-popup-content">
            <span
              className="member-profile-close"
              onClick={() => setIsProfilePopupOpen(false)}
            >
              &times;
            </span>

            <div className="member-profile-header">
              {userImages[selectedUserProfile.user_uid] ? (
                <img
                  src={userImages[selectedUserProfile.user_uid] || undefined}
                  alt={`${selectedUserProfile.first_name} ${selectedUserProfile.last_name}`}
                  className="member-profile-image"
                />
              ) : (
                <FaUserCircle className="member-profile-placeholder" />
              )}
              <div className="member-name-job">
                <h2>{`${selectedUserProfile.first_name} ${selectedUserProfile.last_name}`}</h2>
                <p className="member-job-title">{selectedUserProfile.job_title}</p>
                <p
                  className={`status-label ${selectedUserProfile.user_status === "active" ? "active" : "inactive"
                    }`}
                >

                  {/* uncomment this if active inactive tag needed in modal */}
                  {/* {selectedUserProfile.user_status === "active" ? (
              <>
                <span className="dot green-dot" /> Active
              </>
            ) : (
              <>
                <span className="dot red-dot" /> Inactive
              </>
            )} */}
                </p>
              </div>
            </div>

            <div className="leaderboard-member-details">
              <div className="leaderboard-popup-row">
                <FaEnvelope className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Email:</div>
                  <div className="leaderboard-popup-value">{selectedUserProfile.email}</div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaBuilding className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Department:</div>
                  <div className="leaderboard-popup-value">{selectedUserProfile.department}</div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaPhoneAlt className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Mobile:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.mobile_phone || "-"}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaGlobe className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">Nationality:</div>
                  <div className="leaderboard-popup-value">
                    {selectedUserProfile.nationality || "-"}
                  </div>
                </div>
              </div>
              <div className="leaderboard-popup-row">
                <FaCity className="leaderboard-popup-icon" />
                <div className="leaderboard-popup-text">
                  <div className="leaderboard-popup-label">City:</div>
                  <div className="leaderboard-popup-value">{selectedUserProfile.city || "-"}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </>
) : (
       
          <StreakLeaderboard />
        )}

    </div>
  );
};

export default PublicLeaderboard;
